import { render, staticRenderFns } from "./ListaDePostulantes.vue?vue&type=template&id=73a50571&scoped=true"
import script from "./ListaDePostulantes.vue?vue&type=script&lang=js"
export * from "./ListaDePostulantes.vue?vue&type=script&lang=js"
import style0 from "./ListaDePostulantes.vue?vue&type=style&index=0&id=73a50571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a50571",
  null
  
)

export default component.exports